export var reloadPage = function () {
    window.location.reload();
};
export var replaceLocation = function (path) {
    window.location.replace(path);
};
